/*
Special functions for the DEGS theme.
*/

jQuery(document).ready(function() {
	
    // We're going to add filters to anywhere a key to the four themes appears
    jQuery('.key--theme').addClass('fauxlink');
    // First, find the key and add the links
    jQuery('.key--theme').click(function(){
    	theme = jQuery(this).attr('class').split(' ')[1];
        //alert("You just filtered by "+theme);
        // Hide all the other themes
        jQuery('div.aspiration').hide();
        jQuery('div.aspiration.degs--'+theme).show();
    });
    jQuery('.key--theme.all').click(function(){
    	theme = jQuery(this).attr('class').split(' ')[1];
        //alert("You just filtered by "+theme);
        // Hide all the other themes
        jQuery('div.aspiration').show();
    });

}); 